(function () {
  // Prevent double initialization (Theme Editor / section reloads)
  if (window.warehouseInitialized) return;
  window.warehouseInitialized = true;

  document.addEventListener('DOMContentLoaded', function() {
    // SAMPLE PREFILL FROM URL
if (window.location.pathname.includes('/products/private-cask-sample')) {
  const params = new URLSearchParams(window.location.search);
  const caskId = params.get('cask');

  if (caskId) {
    const input = document.querySelector('input[name="properties[Casknummer]"]');
    if (input) {
      input.value = caskId;
    }
  }
}
  const root = document.querySelector('.warehouse-container');
  if (!root) return;

  // ==============================
  // HELPERS
  // ==============================

  const closeAllDropdowns = () => {
    root.querySelectorAll('.client-tools-wrapper.open, .cask-action-wrapper.open')
      .forEach(el => el.classList.remove('open'));

    root.querySelectorAll('[data-toggle][aria-expanded="true"]')
      .forEach(btn => btn.setAttribute('aria-expanded', 'false'));
  };

  const setCaskExpandedState = (card) => {
    if (!card) return;
    const toggle = card.querySelector('.cask-toggle');
    const content = card.querySelector('.cask-content');
    if (!toggle) return;

    const isOpen = card.classList.contains('open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (content?.id) toggle.setAttribute('aria-controls', content.id);
    
  };

  // Init aria state for all casks (once)
  root.querySelectorAll('.cask-card').forEach(setCaskExpandedState);

  // ==============================
  // CLICK HANDLER (EVENT DELEGATION)
  // ==============================

  root.addEventListener('click', function(e) {
    // 1) DROPDOWN TOGGLE (Client Tools + Manage Cask)
    const insideDropdown = e.target.closest('.client-tools-menu, .cask-action-menu');
if (insideDropdown) {
  e.stopPropagation();
}
    const toggleBtn = e.target.closest('[data-toggle]');
    if (toggleBtn) {
      e.stopPropagation();

      const wrapper = toggleBtn.closest('.client-tools-wrapper, .cask-action-wrapper');
      if (!wrapper) return;

      // close others
      root.querySelectorAll('.client-tools-wrapper.open, .cask-action-wrapper.open')
        .forEach(el => { if (el !== wrapper) el.classList.remove('open'); });

      // toggle this
      wrapper.classList.toggle('open');

      // aria-expanded
      const isOpen = wrapper.classList.contains('open');
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      return;
    }

    // 2) CASK ACCORDION CLICK (only when clicking the toggle area)
    const caskToggle = e.target.closest('.cask-toggle');
    if (caskToggle) {
      const card = caskToggle.closest('.cask-card');
      if (!card) return;

      card.classList.toggle('open');
      setCaskExpandedState(card);
      return;
    }

    // 3) ASSET ACCORDION CLICK
    const assetToggle = e.target.closest('.asset-toggle');
    if (assetToggle) {
      e.stopPropagation();
      const card = assetToggle.closest('.asset-card');
      if (card) card.classList.toggle('open');
      return;
    }

    // 4) CLIENT TOOL LINK (if you still use data-link divs)
    const linkEl = e.target.closest('[data-link]');
    if (linkEl && root.contains(linkEl)) {
      const url = linkEl.dataset.link;
      if (url) window.location.href = url;
      return;
    }

    // 5) CASK ACTION MENU ITEM
    const actionBtn = e.target.closest('[data-action]');
    if (actionBtn && root.contains(actionBtn)) {
      e.stopPropagation();

      const action = actionBtn.dataset.action;
      const caskId = actionBtn.dataset.cask;

      let subject = '';
      let body = '';

      switch (action) {
        case 'sample':
  window.location.href = `/products/private-cask-sample?cask=${caskId}`;
  return;
        case 'regauge':
  window.location.href = `/products/private-cask-regauge?cask=${caskId}`;
  return;
          case 'list':
  window.location.href = `/products/private-cask-market-listing?cask=${caskId}`;
  return;
        case 'offer':
  window.location.href = `/products/private-cask-exit-offer-request?cask=${caskId}`;
  return;
        case 'bottling':
  window.location.href = `/pages/botteling-traject?cask=${caskId}`;
  return;
      }

      if (subject && body) {
        window.location.href =
          "/contact?subject=" + encodeURIComponent(subject) +
          "&body=" + encodeURIComponent(body);
      }

      return;
    }
  });

  // ==============================
  // KEYBOARD HANDLER (EVENT DELEGATION)
  // ==============================

  root.addEventListener('keydown', function(e) {
    // CASK ACCORDION keyboard support on toggle
    const caskToggle = e.target.closest('.cask-toggle');
    if (!caskToggle || !root.contains(caskToggle)) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const card = caskToggle.closest('.cask-card');
      if (!card) return;

      card.classList.toggle('open');
      setCaskExpandedState(card);
    }
  });

  // ==============================
  // OUTSIDE CLICK + ESC
  // ==============================

document.addEventListener('click', function(e) {
  if (e.target.closest('.client-tools-wrapper, .cask-action-wrapper')) return;
  closeAllDropdowns();
});

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });
  });
})();